// Disable ActionCable's automatic disconnect on tab visibility change
// This was causing reconnection issues in production

import { createConsumer } from "@rails/actioncable";

export function disableVisibilityDisconnect(consumer) {
  if (!consumer || !consumer.connection) return consumer;
  
  const connection = consumer.connection;
  
  // Override visibilityDidChange to prevent disconnection
  if (connection.visibilityDidChange) {
    connection.visibilityDidChange = function() {
      console.log('Tab visibility changed, but NOT disconnecting (disabled)');
      // Do nothing - don't disconnect on visibility change
    };
  }
  
  // Also disable in the monitor if it exists
  if (connection.monitor && connection.monitor.visibilityDidChange) {
    connection.monitor.visibilityDidChange = function() {
      console.log('Monitor: Tab visibility changed, but NOT disconnecting (disabled)');
      // Do nothing
    };
  }
  
  // Prevent the connection from being closed on page hide
  if (typeof document !== 'undefined') {
    // Remove any existing visibility change listeners
    document.removeEventListener('visibilitychange', connection.visibilityDidChange);
    document.removeEventListener('visibilitychange', connection.monitor?.visibilityDidChange);
    
    // Add our own that does nothing
    document.addEventListener('visibilitychange', () => {
      console.log(`Tab is now ${document.hidden ? 'hidden' : 'visible'}, keeping connection open`);
    });
  }
  
  console.log('✅ ActionCable visibility-based disconnection DISABLED');
  return consumer;
}